import { render, staticRenderFns } from "./Detailed.vue?vue&type=template&id=0ac1b9ea&scoped=true&"
import script from "./Detailed.vue?vue&type=script&lang=js&"
export * from "./Detailed.vue?vue&type=script&lang=js&"
import style0 from "./Detailed.vue?vue&type=style&index=0&id=0ac1b9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac1b9ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardText,VCol,VContainer,VRow,VSelect,VSkeletonLoader,VSparkline,VSubheader,VSwitch,VTimeline,VTimelineItem})
